import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrescriptionResponseREAPI } from '@interfaces/patient/patient.interface';
import { CallsService } from '@services/api/calls.service';

@Component({
  selector: 'app-estupefaciente',
  templateUrl: './estupefaciente.component.html',
  styleUrls: ['./estupefaciente.component.scss']
})
export class EstupefacienteComponent {

  public prescription: PrescriptionResponseREAPI;
  public qtyControl: FormControl;
  public drugCodeControl: FormControl;
  public medicineName: string | null = null;
  public medicineId: number | null = null;
  private lastLookedUpCode: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EstupefacienteComponent>,
    private callsService: CallsService,
  ) {
    this.prescription = data.prescription;
    this.qtyControl = new FormControl(data.prescription.QtyEstup ?? null);
    this.drugCodeControl = new FormControl(data.prescription.MedicineDrugIdEstup ?? null);
    this.medicineName = data.prescription.MedicineNameEstup || null;
    this.medicineId = data.prescription.MedicineIdEstup || null;
    this.lastLookedUpCode = this.drugCodeControl.value || null;
  }

  onCodeBlur(): void {
    const code = this.drugCodeControl.value;
    if (code && String(code) === this.lastLookedUpCode) return;
    this.lastLookedUpCode = code ? String(code) : null;

    if (code) {
      this.callsService.getMedicineFieldsByDrugId(String(code)).subscribe(res => {
        const med = res?.payload;
        if (med) {
          this.medicineId = med.Id || null;
          this.medicineName = med.Name || null;
        } else {
          this.medicineId = null;
          this.medicineName = null;
        }
      });
    } else {
      this.medicineId = null;
      this.medicineName = null;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close({
      qty: this.qtyControl.value,
      drugId: this.drugCodeControl.value || null,
      drugName: this.medicineName,
      medicineId: this.medicineId,
    });
  }

  onClearClick(): void {
    this.qtyControl.setValue(null);
    this.drugCodeControl.setValue(null);
    this.medicineName = null;
    this.medicineId = null;
  }
}
